import { createContext, useContext } from 'react';

// The active journey, provided by JourneyProvider near the top of the shared shell and read
// by ChatMessage (per-type message renderers) and JourneyContent (the body component).
//
// This module holds NO default journey. JourneyProvider is the single owner of "what the
// default journey is" (it seeds its state with the eager AssistantJourney). Keeping the
// manifest OUT of this module is deliberate: a default of `AssistantJourney` would make
// context.js import journey.jsx, which closes the journeys-registry cycle
// (context → journey →(dyn) content → ChatHistory → ChatMessage → context). With no such
// import here the cycle cannot form — so no `eslint-disable import/no-cycle` is needed
// anywhere along it.
//
// Consequently useJourney() MUST be called under a JourneyProvider; it throws otherwise. In
// production every consumer is (the shell wraps the body in JourneyProvider); only a
// mis-set-up unit test would hit the throw, and the message tells it what to do.
//
// Named `JourneyContext` (not `ExperienceContext`) deliberately: it avoids colliding with
// `@thd-nucleus/experience-context`, and "journey" names the guided-flow concept distinctly
// from nucleus's page-experience config.
export const JourneyContext = createContext(null);

export const useJourney = () => {
  const journey = useContext(JourneyContext);
  if (journey === null) {
    throw new Error('useJourney must be used within a JourneyProvider');
  }
  return journey;
};
